import type { BaseOpportunity } from '@swf/core/models/sports/types/betSlip';

export const getBetNoFromOpportunity = ({
  numberOfLines,
  id
}: Pick<BaseOpportunity, 'numberOfLines' | 'id'>): number =>
  numberOfLines *
  id
    .split('')
    .map((i) => i.charCodeAt(0))
    .reduce((acc, cur) => acc + cur);
